import React, { useReducer, useContext, useState, useEffect } from "react";
import { Dialog, makeStyles, IconButton } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import MaterialTable from "material-table";
import tableIcons, {
    options,
} from "components/universal/table_attributes";
import HistoryDialog from "./HistoryDialog";
import { format24HrDateOnly, format24HrDateTime } from "lib/utils/common_utils";
import ViewIcon from "@material-ui/icons/Visibility";
import { ICON_COLOUR } from "lib/constants/style_constants";
import { ToastMessageContext } from "lib/contexts/message_context";
import UserServices from "lib/services/api/compliance/user_client";
import { BASE_API_URL_BOXR } from "lib/constants";
import { Delete } from "@material-ui/icons";


export default function HistoryTablePopup(props) {
    const { handleClose, open, currentData, name } = props;

    // history

    const [busy, setBusy] = useState(null);


    const [loading, setLoading] = useState(true)
    const [totalCounts, setTotalCounts] = useState(0);
    const [history, setHistory] = useState([])
    const [pages, setPages] = useState(0);
    const [pageSizes, setPageSizes] = useState(5);

    // console.log("hostyooo os======================", name)

    const classes = useStyles();
    const message = useContext(ToastMessageContext)
    // const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
    // const { page, totalCount, pageSize } = tableState;
    const fileHistory = () => {
        setLoading(true)
        const params = {
            page: pages + 1,
            count_per_page: pageSizes,
        }
        const key1 = name
        params[key1] = currentData.id
        UserServices.fetchHistoryFiles(params).then((res) => {
            if (res) {
                setLoading(false)
                setHistory(res.data);
                setTotalCounts(res.total_count)
                // TableAction.setTotalCount(dispatch, res.total_count);
            }
            else {
                setLoading(false)
                setHistory([]);
            }
        }).catch(() => {
            setLoading(false);
        });
    }

    const deleteUploadDoc = (id) => {
        const formData = new FormData();
        formData.set('id', id);
        UserServices.deleteGeneralFiles(formData).then((res) => {
            if (res.success) {
                message.showToastMessage({ open: true, message: res?.message ? res?.message : "Document deleted successfully", variant: "success" });
                fileHistory();

            }
        }).catch(() => {
            message.showToastMessage({ open: true, message: "Something went wrong. Try Again", variant: "error" });
        })

    }
    useEffect(() => {
        fileHistory()
    }, [currentData, pages, pageSizes])
    // tableOptions
    const tableOptions = {
        ...options,
        page: pages,
        total: totalCounts,
        pageSize: pageSizes,
        search: false,
        toolbar: false,
        headerStyle: {
            textAlign: "center",
            paddingTop: "22px",
            paddingBottom: "16px",
        },
    };

    const columns = [
        {
            title: "Date / Time Added",
            field: "datetime",
            width: '80%',
            headerStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: '80%',
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: '80%',
            },
            render: (rowData) => {
                return format24HrDateTime(rowData?.created_at)
            }
        },
        {
            title: "",
            render: (rowData) => (
                <>
                    <IconButton
                        onClick={() => {
                            if (rowData.url) {
                                window.open(`${BASE_API_URL_BOXR}${rowData.url}`);
                            } else {
                                message.showToastMessage({
                                    message: "No Document Found.",
                                    variant: "error",
                                });
                            }
                        }}
                        size="small"
                    >
                        <ViewIcon fontSize="small" style={{ color: ICON_COLOUR }} />
                    </IconButton>
                    {name !== "authorisation_list_id" && <IconButton
                        onClick={() => {
                            if (rowData.id) {
                                deleteUploadDoc(rowData.id)
                            } else {
                                message.showToastMessage({
                                    message: "No Document Found.",
                                    variant: "error",
                                });
                            }
                        }}
                        size="small"
                    >
                        <Delete fontSize="small" style={{ color: ICON_COLOUR }} />
                    </IconButton>}
                </>
            ),
        },
    ];

    return (
        <div style={{ position: "relative" }}>
            <HistoryDialog
                open={open}
                handleClose={handleClose}
                width="481px"
                notShowButton={true}
            >
                <Box
                    width="100%"
                    mb="30px"
                    ml="0px"
                >
                    <Typography color="primary" className={classes.bodyText}>
                        History
                    </Typography>
                </Box>

                <Box width="100%">
                    <MaterialTable
                        style={{ boxShadow: "0px 1px 3px #00000033" }}
                        icons={tableIcons}
                        columns={columns}
                        data={history || []}
                        options={tableOptions}
                        localization={{
                            toolbar: {
                                searchPlaceholder: "Search anything",
                            },
                            body: {
                                emptyDataSourceMessage: "No histories Found",
                                filterRow: {
                                    filterTooltip: "Filter",
                                },
                            },
                        }}
                        isLoading={loading}
                        onChangePage={(page) => {
                            setPages(page);
                        }}
                        onChangeRowsPerPage={(pageSize) => {
                            setPageSizes(pageSize);
                        }}
                        totalCount={totalCounts}
                        page={pages}
                    />
                </Box>
            </HistoryDialog>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    bodyText: {
        fontSize: 20,
        lineHeight: "28px",
    },
}));
